import apis from '@/pages/data-panel/flow-insight/apis';
const FLOWOUT_STATISTICS = 'FLOWOUT_STATISTICS';
const UPDATA_FLOWOUT_PARAM = 'UPDATA_FLOWOUT_PARAM';
const UPDATA_TREND_PARAM = 'UPDATA_TREND_PARAM';
const FLOWOUT_ROOM = 'FLOWOUT_ROOM';
const FLOWOUT_TREND = 'FLOWOUT_TREND';
const FLOWOUT_TYPE1 = 'FLOWOUT_TYPE1';
const FLOWOUT_TYPE2 = 'FLOWOUT_TYPE2';
const FLOWOUT_TYPE3 = 'FLOWOUT_TYPE3';
const UPDATE_ROWKEYS = 'UPDATE_ROWKEYS';
const SET_TABLE_STATUS = 'SET_TABLE_STATUS';
const RESET_PARAM = 'RESET_PARAM';
const SET_CHANNEL_NAME = 'SET_CHANNEL_NAME';
export const outStatistics = (param) => (dispatch, getState) => {
  const params = getState().dataPanel.flowOutStatistics.flowOutParams;
  dispatch({
    type: SET_TABLE_STATUS,
    payload: true,
  });
  apis.outStatistics(param).then((res) => {
    if (res && res.ret === '0') {
      if (params.firstCode || params.firstCode === '') {
        // 一到3级表格的数据后台公用一个接口，只能根据入参请求携带的code来确定赋值给谁
        if (!params.secondCode && params.secondCode !== '') {
          dispatch({
            type: FLOWOUT_TYPE1,
            payload: res.data,
          });
        } else {
          console.log('替换哪一个22');
          dispatch({
            type: FLOWOUT_TYPE2,
            payload: res.data,
          });
        }
      } else {
        dispatch({
          type: FLOWOUT_STATISTICS,
          payload: res.data,
        });
      }
    } else {
      dispatch({
        type: FLOWOUT_STATISTICS,
        payload: {},
      });
    }
    dispatch({
      type: SET_TABLE_STATUS,
      payload: false,
    });
  });
};

export const flowOutTrend = (param) => (dispatch, getState) => {
  apis.flowOutTrend(param).then((res) => {
    if (res && res.ret === '0') {
      dispatch({
        type: FLOWOUT_TREND,
        payload: res.data,
      });
    } else {
      dispatch({
        type: FLOWOUT_TREND,
        payload: {},
      });
    }
  });
};

export const flowOutRoom = (param) => (dispatch, getState) => {
  apis.flowRoom(param).then((res) => {
    if (res && res.ret === '0') {
      dispatch({
        type: FLOWOUT_ROOM,
        payload: res.data,
      });
    } else {
      dispatch({
        type: FLOWOUT_ROOM,
        payload: {},
      });
    }
  });
};

export const updataOutParam = (param) => (dispatch, getState) => {
  // console.log('更新', param)
  dispatch({
    type: UPDATA_FLOWOUT_PARAM,
    payload: param,
  });
};
export const updataTrendParam = (param) => (dispatch, getState) => {
  // console.log('更新', param)
  dispatch({
    type: UPDATA_TREND_PARAM,
    payload: param,
  });
};

export const updateRowKeys = (param) => (dispatch, getState) => {
  // console.log('更新', param)
  dispatch({
    type: UPDATE_ROWKEYS,
    payload: param,
  });
};

export const setLoadStatus = (param) => (dispatch, getState) => {
  dispatch({
    type: SET_TABLE_STATUS,
    payload: param,
  });
};

export const resetParam = () => (dispatch, getState) => {
  dispatch({
    type: RESET_PARAM,
  });
};

export const setChannelName = (param) => (dispatch, getState) => {
  // let title = ''
  // const arr = Object.keys(param)
  // if (arr && arr.length > 0) {
  //   arr.forEach((key) => {
  //     title = '-' + param[key]
  //   })
  // }
  dispatch({
    type: SET_CHANNEL_NAME,
    payload: param,
  });
};
function getInitialState() {
  return {
    list: [],
    roomList: [],
    typeList: [],
    type1List: [],
    type2List: [],
    type3List: [],
    flowOutParams: { type: 302 },
    timeDimension: '',
    detailList: [],
    trendConditions: { type: 302 },
    defaultRowKeys: {},
    channelName: '',
    status: false,
  };
}

const initialState = {
  list: [],
  roomList: [],
  typeList: [],
  type1List: [],
  type2List: [],
  type3List: [],
  flowOutParams: { type: 302 },
  timeDimension: '',
  detailList: [],
  channelName: '',
  trendConditions: { type: 302 },
  defaultRowKeys: {},
  status: false,
};

export default function realActivityPlan(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case FLOWOUT_STATISTICS:
      return Object.assign({}, state, payload);
    case UPDATA_FLOWOUT_PARAM:
      return Object.assign({}, state, { flowOutParams: payload });
    case FLOWOUT_TREND:
      return Object.assign({}, state, payload);
    case UPDATA_TREND_PARAM:
      return Object.assign({}, state, { trendConditions: payload });
    case FLOWOUT_TYPE1:
      return Object.assign({}, state, { type1List: payload.typeList });
    case FLOWOUT_TYPE2:
      return Object.assign({}, state, { type2List: payload.typeList });
    case FLOWOUT_TYPE3:
      return Object.assign({}, state, { type3List: payload.typeList });
    case UPDATE_ROWKEYS:
      return Object.assign({}, state, { defaultRowKeys: payload });
    case SET_TABLE_STATUS:
      return Object.assign({}, state, { status: payload });
    case RESET_PARAM:
      return Object.assign({}, getInitialState());
    case SET_CHANNEL_NAME:
      return Object.assign({}, state, { channelName: payload });
    case FLOWOUT_ROOM:
      return Object.assign({}, state, payload);
    default:
      return state;
  }
}
